import React from 'react';
import Select from 'react-select';

import { FormError } from 'components/Form/FormField';

export const ReactSelectAdapter = ({ input, ...rest }) => (
  <React.Fragment>
    <Select {...input} {...rest} searchable />
    <FormError name={input.name} />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/customSurvey/FormFields/libraryFields.js